import { useEffect } from "react"
import useSound from "use-sound"
import engineSFX from "../lib/audio/engine-loop.mp3"

export const handlePlayEngineSFX = (
  isSoundOff: any,
  sound: any,
  isError: any,
  isLoading: any,
  state: any,
  disableSounds: any,
  errorText: any,
  isJackpot: any,
) => {
  const [playEngineSFX, { stop, sound: engineSound }] = useSound(engineSFX, {
    volume: parseFloat(sound) / 100 >= 0.1 ? 0.1 + parseFloat(sound) / 500 : parseFloat(sound) / 100,
  })

  useEffect(() => {
    if (errorText !== "" && isJackpot) {
      stop()
    }
  }, [errorText, isJackpot])


  useEffect(() => {
    if (engineSound) {
      engineSound._volume =  parseFloat(sound) / 100 >= 0.2 ? 0.2  : parseFloat(sound) / 100
    }
  }, [sound, engineSound])

  
  useEffect(() => {
    !isSoundOff &&
      !isError &&
      !isLoading &&
      state === 2 &&
      !disableSounds &&
      !isJackpot
      ? (() => {
        playEngineSFX()
        engineSound && engineSound.loop(true)
      })()
      : stop()
  }, [
    isSoundOff,
    playEngineSFX,
    stop,
    isError,
    isLoading,
    state,
    disableSounds,
    isJackpot,
  ])
}
